import Box from '@mui/material/Box';
import MessageFrom from 'components/@home/@messages/ChannelsPanel/MessageFrom/MessageFrom';
import MessagePreview from 'components/@home/@messages/ChatPanel/PinnedMessage/MessagePreview';
import { arrayOf, shape, string } from 'prop-types';
import React, { memo } from 'react';
import attachmentsShape from 'shapes/attachment';
import channelShape from 'shapes/channel';

const styles = {
  root: {},
  lastMessage: {
    display: '-webkit-box',
    WebkitLineClamp: '2',
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    overflowWrap: 'break-word',
    lineHeight: '1.2em',
    '& *': {
      verticalAlign: 'text-bottom',
    },
    '& *:first-of-type': {
      marginRight: '2px',
    },
    '& *:last-of-type': {
      marginRight: 0,
    },
    '& > * + *': {
      marginLeft: '3px',
    },
  },
  strong: {
    fontWeight: '500',
  },
};

const LastMessage = ({ lastMessage = null, channel = null }) => {
  if (!lastMessage || !lastMessage.from) return null;
  const channelName = channel?.name?.trim();
  return (
    <Box sx={styles.lastMessage}>
      <MessageFrom message={lastMessage} channel={channel}>
        {name => {
          const trimmed = name?.trim();
          if (!trimmed || trimmed === channelName) return null;
          return (
            <Box component="strong" sx={styles.strong}>
              {trimmed}:
            </Box>
          );
        }}
      </MessageFrom>
      <MessagePreview message={lastMessage} />
    </Box>
  );
};

LastMessage.propTypes = {
  lastMessage: shape({
    attachments: arrayOf(attachmentsShape),
    text: string.isRequired,
    employee_id: string,
  }),
  channel: channelShape.isRequired,
};

const isEqual = (prev, next) => {
  if (prev.lastMessage?.attachments !== next.lastMessage?.attachments) return false;
  if (prev.lastMessage?.text !== next.lastMessage?.text) return false;
  if (prev.lastMessage?.employee_id !== next.lastMessage?.employee_id) return false;
  return true;
};
export default memo(LastMessage, isEqual);
